import React from 'react';

import type { ReactComponentOrElement } from '../models';

export interface FmlContextInterface {
  addOverlay: (id: string, overlay: ReactComponentOrElement, containerElement: HTMLDivElement) => void;
  removeOverlay: (id: string) => void;
}

export const FmlContext = React.createContext<FmlContextInterface>({
  addOverlay: () => {
    return;
  },
  removeOverlay: () => {
    return;
  },
});
